import { useEffect } from "react";

const BackgroundUpdater = () => {

  useEffect(() => {
    // Set background image from data-bg-src
    const bgSrcElements = document.querySelectorAll('[data-bg-src]');
    bgSrcElements.forEach((element) => {
      const src = element.getAttribute('data-bg-src');
      if (src) {
        element.style.backgroundImage = `url(${src})`;
        element.classList.add('background-image');
        element.removeAttribute('data-bg-src');
      }
    });

    // Set background color from data-bg-color
    const bgColorElements = document.querySelectorAll('[data-bg-color]');
    bgColorElements.forEach((element) => {
      const color = element.getAttribute('data-bg-color');
      if (color) {
        element.style.backgroundColor = color;
        element.removeAttribute('data-bg-color');
      }
    });

    // Set mask image from data-mask-src
    const maskSrcElements = document.querySelectorAll('[data-mask-src]');
    maskSrcElements.forEach((element) => {
      const mask = element.getAttribute('data-mask-src');
      if (mask) {
        element.style.maskImage = `url(${mask})`;
        element.style.WebkitMaskImage = `url(${mask})`;
        element.classList.add('bg-mask');
        element.removeAttribute('data-mask-src');
      }
    });
  }, []); 

  return null; 
};

export default BackgroundUpdater;
